module.exports = __webpack_public_path__ + "2e692d1dfce0e139efeda61ce43ba222.svg";